var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.917 7.408 7.083 3.24M2.917 3.241h4.166v4.167",
    stroke: "#D84339",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgArrowUpRight;